module.exports = __webpack_public_path__ + "media/images/guide/keisan_club_guide_green-5e608325260af68389c9ab7e2c460d12.png";